export default __webpack_public_path__ + "static/media/upload.b85c6385.png";